import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { StandardLineChart } from "../../Common/Charts/StandardLineChart";
import ComponentActions from "./ComponentActions";

class LineChartComponent extends Component {
  render() {
    const {
      slideId,
      indicatorsExplanation,
      isPreparePresentation,
      isComposition,
      isPresentation,
      hasComments,
      hasExplanation,
      component: {
        componentId,
        labels,
        data,
        config: {
          NoComponentHeader,
          ConfigComponentHeight,
          annexeAttachmentCategory
        }
      },
      layoutProps: { containerHeight }
    } = this.props;

    return (
      <div>
        {NoComponentHeader ? null : (
          <ComponentHeader
            indicatorsExplanation={indicatorsExplanation}
            slideId={slideId}
            percentage={false}
            title={labels}
            annexeAttachmentCategory={annexeAttachmentCategory}
            handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
            isComposition={isComposition}
            isPresentation={isPresentation}
            hasComments={hasComments}
            hasExplanation={hasExplanation}
            componentId={componentId}
            isPreparePresentation={isPreparePresentation}
            inSlideView={this.props.inSlideView}
          />
        )}

        <div
          className={classnames(
            styles.LineChartComponent,
            styles.flex_container
            // styles.align_container
          )}
        >
          {!this.props.inSlideView &&
            !this.props.isEmbedded && (
              <ComponentActions
                removeComponent={this.props.handleRemoveComponent}
                updateComponent={this.props.handleUpdateComponent}
                componentCase={this.props.ComponentCase}
                sideBar={"MultiIndicatorComponentConfig"}
                component={"LineChartComponent.png"}
              />
            )}
          <span
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
            style={containerHeight ? { alignItems: "baseLine" } : null}
          >
            <StandardLineChart
              chartData={Object.values(data.data)}
              dataKeysY={data.accounts.map(({ code }) => code)}
              dataKeyX={"year"}
              currency={data.accounts[0].unit === "€"}
              legendLabels={data.accounts.map(({ label }) => label)}
              // containerWidth={"xxx%"}
              containerHeight={
                ConfigComponentHeight ? ConfigComponentHeight : containerHeight
              }
            />
          </span>
        </div>
      </div>
    );
  }
}

export default LineChartComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/LineChartComponent.js